import { IPriceOrderParams } from 'hooks/price-order/types';
import { IPriceOrderInput } from 'remote/queries/order';

import { buildCartInput } from './build-cart-input';
import { redeemReward } from './redeem-reward';

export function buildPriceOrderInput(
  params: Omit<IPriceOrderParams, 'redeemReward'>
): IPriceOrderInput {
  return {
    rewardsApplied: params.rewardsApplied,
    cartVersion: params.cartVersion,
    customerName: params.customerName,
    loyaltyBarcode: params.loyaltyBarcode,
    paymentMethod: params.cardType,
    redeemReward,
    ...buildCartInput(params)
  };
}
